import React, { Component } from 'react'
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';

export default class ViewAuditplan extends Component {
    constructor(props) {
        super(props)
        this.state = {
        //   orgCode : props.match.params.orgcode,
        //   auditplanurl: "",

        reportOfauditPlan: {
            orgCode : props.match.params.orgcode,
            auditplanurl: "",
          
        },
        editStatus:false,
        showMessage:false,

          data: {},
          config: {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            dirName: process.env.REACT_APP_DIR_NAME /* optional */,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_ID,
            secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
        },
        buttonStatus: "none",
        downloadbuttonStatus: "none",
        uploadDocumentStatus: "none",
        uploadedDocumentStatus: "none",
        showFile: "Image",
        uploadedProcessUrl: "",
        submitStatus: false,
        uploadStatus : true,
        messageforvalidation :"none",
        isLoading:false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
       const api=APIURL + '/api/rfq/get/orgdetails/' + this.state.reportOfauditPlan.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
          .then(res => {
            if(res.data.errorCode === 0){
                this.setState({data : res.data.response})
             
                if(res.data.response.auditteamproposalStatus  && res.data.response.auditPlanStatus)
                {
                    this.setState({editStatus:true})
                    if ( this.state.data.auditplanurl) {
                        this.setState({ uploadedProcessUrl: this.state.data.auditplanurl })
                        this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block",downloadbuttonStatus:"none" })
                    }
                    else if (! this.state.data.auditplanurl) {
                        this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none",downloadbuttonStatus:"block" })
                    }
                } else if(res.data.response.auditteamproposalStatus && !res.data.response.auditPlanStatus)
                {
                    this.setState({editStatus:true,message:"Need to Fill the Audit Plan Data",showMessage:true})
                } else{
                    this.setState({ editStatus: false , message:"This Company's Audit Team Proposal data not filled.",showMessage:true})
                }
            }
        })
        .catch(e=>{
            console.log("Something went Wrong", e)
            var string = JSON.stringify(e).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);

            console.log("found", found);
            if (found !== null) {
                window.location.href = "/signin"
                //alert("if")
                this.setState({isLoading:true})
            }
        })
          
      }
    handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if(file1 <= 3072 ){
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                var tempData =this.state.reportOfauditPlan;
                tempData.auditplanurl = data.location
                var docType = this.checkFileExtension(data.location)
                var file= data.key.split("/")
                var fileName = file[1];
                this.setState({ auditplanurl: tempData, 
                                showFile: docType,
                                uploadStatus :false, 
                                messageforvalidation : "none",
                                fileToUpload : data.location,
                                filenameToview : fileName
                             });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({filenameToview : "",messageforvalidation : "block"})
        }
    }; 

    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }

    removeDoc = () => {
        var tempData = this.state.reportOfauditPlan;
        tempData.auditplanurl = ""
        this.setState({  reportOfauditPlan: tempData ,uploadStatus :true});
    }
    removeUplodedDoc = () => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest ={
                                        "orgCode" :this.state.data.orgCode
                    }
                    axios.patch(APIURL + "/api/rfq/patch/auditplanurl",jsonRequest)
                    .then((res) => {
                        if (res.data.errorCode === 0) {
                    this.setState({ 
                        uploadDocumentStatus: "block", 
                        uploadedDocumentStatus: "none", 
                        uploadProcessUrl: "" ,
                        uploadStatus : true ,
                        uploadedProcessUrl:"",
                        editStatus : true
                    })
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
               
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

        }
    })
}
    
    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+'/auditplan/' +this.state.reportOfauditPlan.orgCode;
    }

    generateReviewProcess = () => {
        return axios.get(APIURL+'/api/generatepdf/get/auditplanpdf/' + this.state.reportOfauditPlan.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        ) 
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.data.orgSerialNumber + '- Audit Plan' + `.pdf`
                link.click()
            })
    }

    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfauditPlan.orgCode,
            auditplanurl: this.state.reportOfauditPlan.auditplanurl,
        }
        axios.patch(APIURL + "/api/rfq/patch/auditplanurl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'stage 1 Audit Plan Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
      

    }
    render() {
         const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfauditPlan.auditplanurl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadUploadPdf()}/>
                    <p>{this.state.filenameToview}</p>
                    <span>
                        <h6 onClick={() => this.removeDoc('auditplanurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                <div className="row">
                <div className="col-sm-12">
                        <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={()=>this.downloadUploadPdf()}/>
                        <span>
                            <h6 onClick={() => this.removeDoc('auditplanurl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                        </span>
                        </div>
                         <div className="row">
                             <span>{this.state.filenameToview}</span>

                         </div>
                     </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
    return (
        <div>
        
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                        {
                                this.state.showMessage  ?

                                    <div className="text-center"><p style={{fontSize:"25Px" ,color:"red"}}>{this.state.message}</p></div>
                                :
                                    null
                            }
                            <div className="col-sm-12">
                                <div className="card-body" style={{ paddingLeft: "50px" }}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Client Name</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>
                                                    </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Auditee’s Representative</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.auditrepresentative}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Objective</label>
                                                    <div className="col-sm-9">
                                                        <p> {this.state.data.auditobjective}</p>
                                                    </div>
                                                    </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Scope of Application</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.scope} </p>                                               </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Standard Applied</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.standardapplied}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Standard Not Applicable Requirement</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.standardapplicable}</p>                                                </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Type of Audit</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.typeofaudit}  </p>                                              </div>

                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date Of Audit From</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofaudit).format('DD-MMM-YYYY')}</p>                                                    {/* <FormikControl control='input' type="text" name='dateofaudit' /> */}
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date Of Audit To</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofauditto).format('DD-MMM-YYYY')}</p>                                                    {/* <FormikControl control='input' type="text" name='dateofaudit' /> */}
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Team Leader / Auditor(s) / Provisional Auditor(s)</label>
                                                    <div className="col-sm-3">
                                                        <p> {this.state.data.teamleaderName} </p>                                               </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Technical Expert</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.technicalExpertName ==="" ? "NA" : this.state.data.technicalExpertName } </p>                                               </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Persons accompanying with Audit Team (if any)</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.accompanyingteam} </p>    
                                                        </div>

<div className="row mt-4">                                           </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Purpose</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.purpose} </p>                                             </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Product Categories & Business Sector:IAF/NABCB-SIC Code(s)</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.purposecategories}    </p>                                            </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Translator(s)</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.translator}  </p>                                              </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Language of Audit</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.languageofaudit}   </p>                                             </div>
                                                        </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Reference Documents</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.referencedocuments}   </p>                                                 {/* <FormikControl control='textarea' type="text" name='referencedocuments' /> */}
                                                    </div>
                                                </div>
                                                  
                                                <h6 className="mt-5"><b >Confidentiality Requirements:  Certification activities will be held in strict confidence as defined in the Master Agreement (MA) of IQCPL..</b></h6>
                                                <hr />
                                                <label className="labelsize">Process Details</label>
                                                <div className="row mt-4">
                                                    
                                                    <div className="card-body table-responsive">
                                                        <table className="table table-bordered " >
                                                            <thead className="table-primary">
                                                                <tr>
                                                                    <th scope="col" className="text-center">#</th>
                                                                    <th scope="col" className="text-center">Date of Audit</th>
                                                                    <th scope="col" className="text-center">Process to be Audited</th>
                                                                    {/* <th scope="col" className="text-center">Process Selection</th> */}
                                                                    <th scope="col" className="text-center">Process Group </th>
                                                                    <th scope="col" className="text-center">Minutes Assigned </th>
                                                                    <th scope="col" className="text-center">Auditee</th>
                                                                    <th scope="col" className="text-center">Auditor Compulsion</th>
                                                                    <th scope="col" className="text-center">Proposed Time</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody >
                                                                {
                                                                   this.state.data && this.state.data.processDetails && this.state.data.processDetails.length && this.state.data.processDetails.length >0 ?
                                                                  this.state.data.processDetails.map((item, index) => {
                                                                   console.log("processDetails", this.state.data.processDetails)
                                                                   
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td className="text-center">{index + 1}.</td>
                                                                                <td>{moment(item.dateofaudit).format("DD-MMM-YYYY")}</td>
                                                                                <td>{item.processNametobeAudited}</td>
                                                                                {/* <td>{item._id}</td> */}
                                                                                {/* <td>{item.checkBoxSelection}</td> */}
                                                                                <td>{item.processGroup}</td>
                                                                                <td className="text-center">{item.minutesAssigned}</td>
                                                                                <td>{item.auditee}</td>
                                                                                <td>{item.auditorCompulsion}</td>
                                                                                <td className="text-center">{item.proposedValue}</td>

                                                                                
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <>No Process Details have been added yet </>
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                        </div>

                                        
                                        <div>
                                                                <div className="row mt-4">
                                                                    <hr className="mt-4" />
                                                                    <div className="col-sm-6 text-dark ">
                                                                        <h5>Download Audit Plan Report</h5>
                                                                    </div>
                                                                    <div className="col-sm-4"/>
                                                                    <button className="btn btn-primary btn-sm col-sm-2 mb-2" onClick={() => this.generateReviewProcess()}>Download</button>
                                                                    
                                                                    <hr />
                                                                    {/* <div className="row">
                                                                        <div className="col-sm-10" />
                                                                       
                                                                        <button className="btn btn-primary col-sm-2" onClick={() => this.generateReviewProcess()}>Download</button>
                                                                    </div> */}
                                                                </div>
                                         </div>
                                         {
                                                       localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      ""
                                                      :
                                                  <div style={{ display: this.state.uploadDocumentStatus }}>
                                                <div className="row mt-4">
                                                   <hr className="mt-4" />
                                                   <div className="col-sm-6 text-dark ">
                                                       <h5>Upload Audit Plan Report</h5>
                                                </div>
                                                   <hr />

                                                       <div className="row mt-5" >
                                                           <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload Audit Plan </label></div>
                                                           <div className="col-sm-6">
                                                           <p style={{color:"red" ,display:this.state.messageforvalidation}}>Please Select Size Which is less than 3 MB</p>
                                                               {
                                                                  this.state.reportOfauditPlan.auditplanurl !== "" ?
                                                                       <FileReviewProcess />
                                                                       :
                                                                       <>
                                                                           <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                           <br></br>

                                                                       </>
                                                               }
                                                           </div>
                                                           </div>
                                                           <div className="row">
                                                           <div className="col-sm-6" />
                                                                <div className="col-sm-4" />
                                                       
                                                       <button type="button" className="btn btn-sm btn-success col-sm-2 mb-2 mr-2" onClick={() => this.postData()} disabled={this.state.uploadStatus}>Upload</button>

                                                   </div>
                                                </div>
                                                       </div>
                                  }
                                                

                                                   <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                         <h5>Uploaded Audit Plan</h5>
                                                        </div>
                                                        <hr />
                                                        <div className="col-sm-4">

                                                            <label className="mt-4 labelsize">
                                                                 Uploaded Audit Plan 
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }}  onClick={()=>this.downloadSignedPdf()}/>
                                                                        <p>{this.state.filenameToview}</p>
                                                                    {    localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                                            ""
                                                                            :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        }
                                                                    </>
                                                                    :
                                                                    this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={()=>this.downloadSignedPdf()} />
                                                                            {    localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                                            ""
                                                                            :
                                                                              <span>
                                                                                <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                               </span>
                                                                                }
                                                                        </>

                                                                        :
                                                                        ""
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      
                                                      !this.state.uploadedProcessUrl  ?
                                                      <>
                                                     
                                                     
                                                         <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>
                                                             
                                                               </> 
                                                                
                                                                :
                                                                ""
                                                                :
                                                                ""

                                                }

                                                  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            { 
                    localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Accounts"  || localStorage.getItem("userRole")==="Executive(Support)"?
                    ""
                    :
             <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                {
                                    
                                    this.state.editStatus  ?
                                    ! this.state.uploadedProcessUrl ?
                                    <button type="submit" className="btn btn-primary float-right" onClick={() => this.handleRoute()}>Edit</button>
                                    : 
                                    <div></div>
                                    :"" 
                                }
                              </div>
                                
                            </div>
                            </div> 
    }
    
    </div>
        
    )
}
    }